import React from 'react'
import BrandFormBase from './BrandFormBase'

const EditBrandForm: React.FC = () => {
  return <BrandFormBase isEditMode />
}

export default EditBrandForm
